import React, { useState, useCallback } from "react";
import { useInitOtp } from "../../lib/services/auth-service";
import { getLoggedinUser } from "../../lib/util";

const SignUpForm = ({
  setShowLogin,
  onLoginSuccess,
  setTokenType,
  setSessionId,
  setToken,
  setOtpData,
  setSignUpData,
  setTarget,
  fromChat,
}) => {
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");

  const { isLoading, mutate: mutateInitOtp } = useInitOtp({
    onError: (response) => {
      setError(response.message);
    },
    onSuccess: (response) => {
      const { token, tokenType, sessionId } = response.data;
      setTokenType(tokenType);
      setSessionId(sessionId);
      setToken(token);
      setTarget("signup");
      setOtpData({ ...response.data, waitTime: response.data.waitTime });
      setShowLogin(false); // Switch to OTP form if needed
    },
  });

  const togglePasswordVisibility = useCallback(() => {
    setPasswordVisible((prev) => !prev);
  }, []);

  const handlePasswordChange = useCallback((e) => {
    setPassword(e.target.value);
    setError("");
  }, []);

  const handleEmailChange = useCallback((e) => {
    setEmail(e.target.value);
    setError("");
  }, []);

  const handleSignUpSubmit = useCallback(
    (e) => {
      e.preventDefault();
      const formData = new FormData(e.target);
      const data = Object.fromEntries(formData.entries());
      setSignUpData({ ...data, email, password });
      mutateInitOtp({
        target: "signup",
        identifier: email,
        type: "email",
        displayName: data.displayName || "",
      });
    },
    [email, password, mutateInitOtp]
  );

  return (
    <div className="auth-form-container auth-form-container-login">
      <h2>Create a Circleplug account</h2>
      {!fromChat && <h4>Sign up to start shopping with us</h4>}
      {error && <div className="error-message">{error}</div>}
      <div className="input-container">
        <form onSubmit={handleSignUpSubmit}>
          <div className="auth-bot-field" aria-hidden="true">
            <label htmlFor="signup-display-name">Display name</label>
            <input
              type="text"
              id="signup-display-name"
              name="displayName"
              tabIndex={-1}
              autoComplete="off"
            />
          </div>
          <div className="input-box">
            <label htmlFor="firstName">First Name:</label>
            <div className="input-text">
              <input
                type="text"
                id="firstName"
                name="firstName"
                required
                placeholder="First Name"
              />
            </div>
          </div>
          <div className="input-box">
            <label htmlFor="lastName">Last Name:</label>
            <div className="input-text">
              <input
                type="text"
                id="lastName"
                name="lastName"
                required
                placeholder="Last Name"
              />
            </div>
          </div>
          <div className="input-box">
            <label htmlFor="email">Email:</label>
            <div className="input-text">
              <input
                type="email"
                id="email"
                name="email"
                value={email}
                onChange={handleEmailChange}
                required
                placeholder="Email"
              />
            </div>
          </div>
          <div className="input-box password-box">
            <label htmlFor="password">Password:</label>
            <div className="input-text">
              <input
                type={passwordVisible ? "text" : "password"}
                id="password"
                name="password"
                value={password}
                onChange={handlePasswordChange}
                required
                placeholder="Password"
                autocomplete="off"
              />
              <button
                type="button"
                className="toggle-password"
                onClick={togglePasswordVisibility}
              >
                <i
                  className={`fa ${
                    passwordVisible ? "fa-eye-slash" : "fa-eye"
                  }`}
                  aria-hidden="true"
                ></i>
              </button>
            </div>
          </div>
          <button
            type="submit"
            className="auth-submit-button"
            disabled={isLoading} // Disable button if loading
          >
            {isLoading ? "Signing Up..." : "Sign Up"}
          </button>
        </form>
        <p className="auth-login-nav">
          Already have an account?{" "}
          <span className="auth-toggle" onClick={() => setShowLogin(true)}>
            Sign in
          </span>
        </p>
      </div>
    </div>
  );
};

export default SignUpForm;
